document.addEventListener('DOMContentLoaded', () => {
  const excludedPages = ['/cart', '/checkout'];
  if (excludedPages.some(page => window.location.pathname.startsWith(page))) return;

  const popupOverlay = document.getElementById('custom-popup-overlay');
  const popupClose = document.getElementById('popup-close');
  const optinKey = 'popupOptinCompleted';
  const shownKey = 'popupShownThisSession';
  let hasPopupShown = false;

  // SESSION COOKIE FUNCTIONS
  function setSessionCookie(name, value) {
    // Session cookies have no expiration date
    document.cookie = name + "=" + value + "; path=/";
  }

  function getSessionCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const parts = cookies[i].split("=");
      if (parts[0] === name) return parts[1];
    }
    return null;
  }

  // ✅ TOGGLE THIS FOR TESTING:
  const isTesting = false; // Change to true to force popup during dev

  if (isTesting) {
    console.log('🧪 TESTING MODE — Resetting popup state');
    localStorage.removeItem(optinKey);
    // Clear session cookie by setting an expiration in the past
    document.cookie = shownKey + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  const optinCompleted = localStorage.getItem(optinKey) === 'true';

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / scrollableHeight) * 100;

    // Check session cookie instead of localStorage for session flag
    if (optinCompleted || hasPopupShown || getSessionCookie(shownKey) === 'true') return;

    if (scrollPercent >= 25) {
      console.log('✅ Showing popup');
      popupOverlay.style.display = 'flex';
      setSessionCookie(shownKey, 'true');
      hasPopupShown = true;
    }
  };

  window.addEventListener('scroll', () => {
    handleScroll();
  });

  popupClose.onclick = () => {
    popupOverlay.style.display = 'none';
  };

  window.onclick = (event) => {
    if (event.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  };

  document.addEventListener('click', function (e) {
    const clickedButton = e.target.closest('button, a');
    if (clickedButton) {
      const buttonText = clickedButton.textContent.trim().toLowerCase();
      if (buttonText.includes("no, thanks")) {
        popupOverlay.style.display = 'none';
        e.stopImmediatePropagation();
      }
    }
  });

  // ✅ Prevent popup from showing again after opt-in
  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail.type === 'submit' && e.detail.formId === 'SnDfXF') {
      console.log('📨 Opt-in submitted');
      localStorage.setItem(optinKey, 'true');
      popupOverlay.style.display = 'none';
    }
  });

  // Removed beforeunload session clearing as session cookies automatically clear on browser close.
});
